import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'
import { Progress } from 'reactstrap'

const propTypes = {
  document: PropTypes.object,
  linkResolver: PropTypes.func
}

class InfoSection extends Component {
  render() {
    let { 
      document,
      linkResolver
    } = this.props

    return (
      <section className="section-info">
        <div className="hero-banner" style={{backgroundImage: `url(${document.product_banner_image.url})`}}></div>

        <div className="container">

          <div className="flexbox">
            <div className="flex-item half">
              <div className="info-card">
                {PrismicReact.RichText.render(document.product_title)}
                <ul className="flexbox strain-info-list">
                  <li>THC: {document.strain_thc_levels}</li>
                  <li>CBD: {document.strain_cbd_levels}</li>
                  <li>{document.strain_type}</li>
                </ul>
                {PrismicReact.RichText.render(document.product_description)}
                <Link to={PrismicReact.Link.url(document.buy_link, linkResolver)} className="button button-large">{document.buy_link_name}</Link>
              </div>
            </div>
            <div className="flex-item half">
              <div className="terpene-profile">
                {PrismicReact.RichText.render(document.terpene_profile_title)}
                <ul>
                  {
                    document.terpene_profile.map((t, index) => {
                      return (
                        <li key={index} className="flexbox">
                          <span className="terpene-name">{t.name}</span>
                          <div className="progress-wrapper">
                            <Progress value={t.percentage}></Progress>
                            <span className="progress-percentage">{t.percentage}%</span>
                          </div>
                        </li>  
                      )
                    })
                  }
                </ul>
              </div>
            </div>
          </div>

          <div 
            className="icon-container flexbox"
            style={{
              justifyContent: document.pairs_with_section.length > 0 ? '' : 'center'
            }}
          >
            {
              document.pairs_with_section.length > 0
              ?
              <div className="flex-item three-quarters icon-group">
                {PrismicReact.RichText.render(document.pairs_with_title)}
                <ul className="flexbox icon-list">
                  {
                    document.pairs_with_section.map((p, index) => {
                      return (
                        <li key={index}>
                          <img src={p.icon_large.url} alt={PrismicReact.RichText.asText(p.icon_name)} className="icon"/>
                          {PrismicReact.RichText.render(p.icon_name)}
                        </li>                     
                      )
                    })
                  }
                </ul>
              </div>
              : 
              ""
            }
            <div className={`flex-item ${document.pairs_with_section.length > 0 ? 'quarter' : 'half'} icon-group`}>
              {PrismicReact.RichText.render(document.dominant_aroma_title)}
              {/* <ul className="flexbox icon-list" style={{ justifyContent: document.dominant_aroma_section.length === 1 ? 'center' : 'space-between'}}> */}
              <ul className="flexbox icon-list" style={{ justifyContent: 'center'}}>
                {
                  document.dominant_aroma_section.map((p, index) => {
                    return (
                       <li key={index}>
                        <img src={p.icon_large.url} alt={PrismicReact.RichText.asText(p.icon_name)} className="icon"/>
                        {PrismicReact.RichText.render(p.icon_name)}
                       </li>               
                    )
                  })
                }
              </ul>
            </div>
          </div> 
        </div>
      </section>
    )
  }
}

InfoSection.propTypes = propTypes

export default InfoSection


// WEBPACK FOOTER //
// ./src/components/ProductPage/InfoSection.js